import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetSharesUsers } from '../../api/Shares';

import UsersFilter from '../Filters/Users';

import { userIsAdmin } from '../../helpers/Auth';

const SharesFilters = ({
  selectedUser,
  defaultSelectedUser,
  scope,
  search,
  sharesTotal,
  loading,
  handleChangeSearch,
  handleSubmitSearch,
  handleResetSearch,
  handleChangeUser,
}) => {
  const intl = useIntl();
  const searchRef = useRef();

  const loadUsers = useCallback(() => (
    APIgetSharesUsers({ scope })
  ), [scope]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmitSearch();
    }
  };

  return (
    <div className="table-filters">
      {userIsAdmin() && (
        <UsersFilter
          selectedUser={selectedUser}
          defaultSelectedUser={defaultSelectedUser}
          loading={loading}
          loadUsers={loadUsers}
          handleChangeUser={handleChangeUser}
        />
      )}
      {(sharesTotal > 0 || search) && (
        <div className="position-relative inline-search">
          <Input
            id="shares-search"
            name="shares-search"
            bsSize="sm"
            innerRef={searchRef}
            placeholder={intl.formatMessage({ defaultMessage: 'Type something and press Enter to search' })}
            disabled={loading}
            onChange={handleChangeSearch}
            onKeyUp={handleKeyPress}
            value={search || ''}
          />
          {search && (
            <a
              href="#clear"
              className="search-clear"
              onClick={handleResetSearch}
            >
              <i className="fas fa-times" />
            </a>
          )}
        </div>
      )}
    </div>
  );
};

SharesFilters.propTypes = {
  selectedUser: PropTypes.object,
  defaultSelectedUser: PropTypes.object,
  scope: PropTypes.string.isRequired,
  search: PropTypes.string,
  sharesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  handleChangeSearch: PropTypes.func.isRequired,
  handleSubmitSearch: PropTypes.func.isRequired,
  handleResetSearch: PropTypes.func.isRequired,
  handleChangeUser: PropTypes.func.isRequired,
};

SharesFilters.defaultProps = {
  selectedUser: null,
  defaultSelectedUser: null,
  loading: false,
  search: '',
};

export default SharesFilters;
